import { render, staticRenderFns } from "./AssetTypeStatus.vue?vue&type=template&id=11ce21f0"
import script from "./AssetTypeStatus.vue?vue&type=script&lang=js"
export * from "./AssetTypeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports